// Hot oferta dnia: kafelek nad czatem („%” i licznik), karta po dotknięciu, ceny hot na kartach i PDP w oknie.
// Stany liczone z zegara przeglądarki: before (odliczanie do startu), live (odsłonięte, klikalne), after (odliczanie do jutra 20:00).
// TREŚĆ (zdjęcia, nazwy, linki) zależy wyłącznie od zegara SERWERA: snippets/etolie-hot-oferta.liquid przed 20:00 renderuje
// tylko zajawki 8×10 px i ceny, a atrybut data-faza mówi, jaką treść strona dostała. Gdy stan przeglądarki wyprzedza treść
// (karta otwarta przed startem, strona z cache, po 20:30 czekanie na jutrzejszą ofertę), dociągamy świeżą treść
// przez Section Rendering API (?section_id=etolie-hot-oferta) i podmieniamy tylko listę produktów, żeby otwarta karta nie mrugała.
const DOBA = 24 * 3600 * 1000;
const SEKCJA = 'etolie-hot-oferta';
const LIMIT_PROB = { live: 400, after: 40, before: 40 }; // w oknie co 5 s (pierwsza minuta), potem co 30 s

const money = (grosze) => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(grosze / 100); // ten sam zapis co reszta sklepu: 469,00 zł

function odliczanie(ms, krotko = false) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
  if (h) return krotko ? `${h}:${String(m).padStart(2, '0')}` : `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`; // w kafelku bez sekund, żeby nie dotykać krawędzi
  return `${m}:${String(r).padStart(2, '0')}`;
}

class EtolieHotOferta extends HTMLElement {
  connectedCallback() {
    this.przyjmij(this);
    if (!this.start) return;
    this.tile = this.querySelector('.etolie-hot__tile');
    this.card = this.querySelector('dialog');
    this.tile.addEventListener('click', () => this.open());
    this.card.querySelector('.etolie-hot__close').addEventListener('click', () => this.card.close());
    this.card.addEventListener('click', (event) => { if (event.target === this.card) this.card.close(); });
    this.stan = null;
    this.proby = 0;
    this.ostatniPobor = 0;
    this.pobieram = false;
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
    this.blysk();
    this.blyskInterval = setInterval(() => this.blysk(), 10000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    clearInterval(this.blyskInterval);
  }

  open() {
    if (!this.querySelector('[data-hot-list] li')) this.odswiez(); // zapowiedź bez produktów: może już są
    if (typeof this.card.showModal === 'function') this.card.showModal(); // ramkę fokusu na krzyżyku (Safari iOS) zdejmuje wspólny assets/etolie-focus.js
  }

  // Przebłysk jak „Marki” w menu: jeden przebieg co 10 s (Jarek 14.09) na „%” w kafelku i na cenach w karcie (Jarek 15.09).
  blysk() {
    this.querySelectorAll('.etolie-hot__pct, .etolie-hot__item-price').forEach((el) => {
      el.classList.remove('is-shine');
      void el.offsetWidth;
      el.classList.add('is-shine');
    });
  }

  // Dane z elementu: własnego przy starcie albo świeżo pobranego z serwera (wtedy podmieniamy listę i JSON, karta zostaje otwarta).
  przyjmij(zrodlo) {
    const start = new Date(zrodlo.dataset.start), end = new Date(zrodlo.dataset.end);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) { this.start = null; return; }
    this.start = start;
    this.end = end;
    this.faza = zrodlo.dataset.faza;
    this.data = zrodlo.dataset.date;
    this.wersja = zrodlo.dataset.wersja;
    if (zrodlo !== this) {
      ['start', 'end', 'date', 'faza', 'teraz', 'wersja'].forEach((k) => { this.dataset[k] = zrodlo.dataset[k] || ''; });
      this.querySelector('[data-hot-list]').innerHTML = zrodlo.querySelector('[data-hot-list]')?.innerHTML || '';
      this.querySelector('[data-hot-items]').textContent = zrodlo.querySelector('[data-hot-items]')?.textContent || '[]';
      this.querySelector('.etolie-hot__lead').innerHTML = zrodlo.querySelector('.etolie-hot__lead')?.innerHTML || '';
      this.stan = null; // klasy, etykiety i oznaczenia od nowa przy najbliższym ticku
      this.proby = 0;
    }
    this.items = JSON.parse(this.querySelector('[data-hot-items]')?.textContent || '[]');
    this.mapa = null;
  }

  // Świeża treść z serwera; to serwer decyduje, co wolno pokazać (przestawiony zegar w telefonie niczego nie odsłoni).
  async odswiez() {
    if (this.pobieram) return;
    this.pobieram = true;
    try {
      const url = new URL('/', location.origin);
      url.searchParams.set('section_id', SEKCJA);
      // Cache renderowania Shopify ignoruje nieznane parametry (t=, nagłówki no-cache), a wyrenderowaną sekcję trzyma minutami;
      // losowy page= wchodzi do klucza cache, więc każde pobranie jest świeżym renderem (test 14.09 na MAIN).
      url.searchParams.set('page', String(100000 + Math.floor(Math.random() * 900000)));
      const r = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
      if (!r.ok) return;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const sekcja = doc.querySelector(`#shopify-section-${SEKCJA}`);
      if (!sekcja) return; // to nie jest odpowiedź sekcji (np. strona błędu), nic nie zmieniamy
      const nowy = sekcja.querySelector('etolie-hot-oferta');
      if (!nowy) { this.koniec(); return; } // metapole puste: nie ma oferty ani na dziś, ani na jutro, kafelek znika
      if (nowy.dataset.faza !== this.faza || nowy.dataset.date !== this.data || nowy.dataset.wersja !== this.wersja) { this.przyjmij(nowy); this.tick(); }
    } catch (e) {
      // sieć: spróbujemy przy następnym ticku
    } finally {
      this.pobieram = false;
    }
  }

  koniec() {
    this.hidden = true;
    clearInterval(this.interval);
    clearInterval(this.blyskInterval);
    this.odznacz();
  }

  tick() {
    const teraz = new Date();
    const stan = teraz < this.start ? 'before' : teraz < this.end ? 'live' : 'after';
    // Po końcu oferty kafelek znika (otwarta karta zostaje do zamknięcia): licznik do „jutra o tej samej porze” bywał nieprawdą
    // (oferta o innej godzinie, brak jutrzejszej oferty); jutrzejsza wraca sama, gdy sprzątanie zapisze nowe metapole.
    this.hidden = stan === 'after' && !this.card.open;
    const doKiedy = stan === 'live' ? this.end : stan === 'after' ? new Date(this.start.getTime() + DOBA) : this.start;
    // Kafelek: dwukropek w osobnym elemencie mruga co sekundę (CSS), bo bez sekund „19:20” wyglądało jak godzina, nie odliczanie
    // (Jarek 15.09). Element przebudowujemy tylko przy zmianie tekstu, żeby co tick nie restartować mrugania.
    const czas = this.querySelector('[data-hot-time]');
    const tekst = stan === 'live' ? '' : odliczanie(doKiedy - teraz, true); // w trakcie: zielona kropka (CSS), bez licznika
    if (czas.dataset.tekst !== tekst) {
      czas.dataset.tekst = tekst;
      const [h, m] = tekst.split(':');
      czas.innerHTML = tekst ? `${h}<span class="etolie-hot__kropka">:</span>${m}` : '';
    }
    this.querySelector('[data-hot-timer]').textContent = odliczanie(doKiedy - teraz); // w karcie z sekundami, licznik ma żyć (Jarek 14.09 21:53)
    if (stan !== this.stan) {
      this.stan = stan;
      this.classList.toggle('is-before', stan === 'before');
      this.classList.toggle('is-live', stan === 'live');
      this.classList.toggle('is-after', stan === 'after');
      this.querySelector('[data-hot-timer-label]').textContent = stan === 'live' ? this.dataset.labelRemaining : this.dataset.labelToStart;
      if (stan === 'live') this.oznacz(); else this.odznacz();
    }
    if (stan === 'live') this.oznacz(); // co sekundę: doładowane kafelki i cena po zmianie wariantu (idempotentne)
    const pdpTimer = document.querySelector('[data-hot-pdp-timer]');
    if (pdpTimer) pdpTimer.textContent = odliczanie(this.end - teraz);
    // Treść w tyle za zegarem (karta otwarta przed 20:00, strona z cache) albo po oknie czekanie na jutrzejszą ofertę:
    // dociągamy z serwera. W oknie co 5 s przez pierwszą minutę (odsłonięcie ma być natychmiastowe), potem co 30 s.
    const zapowiedz = stan === 'before' && this.card.open && !this.querySelector('[data-hot-list] li'); // otwarta karta czeka na produkty
    const zaleglosc = stan !== this.faza || stan === 'after' || zapowiedz;
    if (zaleglosc && this.proby < LIMIT_PROB[stan]) {
      const co = stan === 'live' && this.proby < 12 ? 5000 : 30000;
      if (teraz - this.ostatniPobor >= co) { this.ostatniPobor = teraz.getTime(); this.proby += 1; this.odswiez(); }
    }
  }

  // W trakcie oferty: plakietka i cena hot na kafelkach oraz na stronie produktu (elementy dodatkowe, nic nie podmieniamy).
  // 19.10.2026 (103 produkty): jedna mapa i jedno przejście po kafelkach zamiast zapytania DOM na każdy produkt co sekundę.
  oznacz() {
    if (!this.mapa) this.mapa = new Map(this.items.map((item) => [String(item.product_id), item]));
    const low = (item) => `${this.dataset.labelLowest}: ${money(item.lowest30)}`;
    const procent = (item) => Math.round((1 - item.hot / item.regular) * 100);
    const kolor = (item) => (item.color ? ` · ${item.color}` : '');
    document.querySelectorAll('.etolie-card[data-product-id]').forEach((card) => {
      const item = this.mapa.get(card.dataset.productId);
      if (!item || card.querySelector('.etolie-hot__flag')) return;
      const media = card.querySelector('.etolie-card__media');
      const price = card.querySelector('[data-etolie-card-price]');
      if (media) media.insertAdjacentHTML('beforeend', `<span class="etolie-hot__flag">HOT −${procent(item)}%${kolor(item)}</span>`);
      // Oferta na jeden kolor: kafelek pokazuje inne kolory w zwykłej cenie, więc tylko plakietka z nazwą koloru.
      if (price && !item.variant_ids) { price.hidden = true; price.insertAdjacentHTML('afterend', `<div class="etolie-hot__cardprice"><b>${money(item.hot)}</b><small>${low(item)}</small></div>`); }
    });
    const pdp = document.querySelector('etolie-pdp-content[data-product-id]');
    const item = pdp && this.mapa.get(pdp.dataset.productId);
    if (pdp && item) {
      const ceny = 'product-price .price__regular .price, product-price .price-item--sale.price, .etolie-pdp-atc-price > span, .sticky-add-to-cart__button-price > span';
      // Oferta na jeden kolor (variant_ids z metapola): inny wybrany kolor = zwykła cena, bez linijki HOT (18.10.2026).
      const form = (pdp.closest('.shopify-section') || document).querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      const wariant = Number(form?.value || pdp.dataset.variantId || 0);
      if (item.variant_ids && !item.variant_ids.includes(wariant)) {
        pdp.querySelector('.etolie-hot__pdp')?.remove();
        document.documentElement.classList.remove('etolie-hot-live');
        document.querySelectorAll(ceny).forEach((node) => { if ('etolieCena' in node.dataset) { node.textContent = node.dataset.etolieCena; delete node.dataset.etolieCena; } });
        return;
      }
      document.documentElement.classList.add('etolie-hot-live');
      if (!pdp.querySelector('.etolie-hot__pdp')) {
        pdp.insertAdjacentHTML('afterbegin', `<div class="etolie-hot__pdp"><span class="etolie-hot__pdp-line"><span class="etolie-hot__dot"></span>HOT −${procent(item)}%${kolor(item)} · ${this.dataset.labelToEnd} <b data-hot-pdp-timer></b></span><small>${low(item)}</small><small class="etolie-hot__pdp-kody">${this.querySelector('[data-hot-ikona-kodu]')?.innerHTML || ''}<span>${this.dataset.labelCodes}</span></small></div>`);
      }
      // Cena hot wszędzie tam, gdzie karta produktu pokazuje cenę (główna, przycisk, pasek), żeby nie myliła z regularną.
      // .price__regular .price = produkt bez stałej przeceny (do 18.10 ta cena znikała w oknie, Otwarte 2 z 19.09).
      document.querySelectorAll(ceny).forEach((node) => {
        if (node.textContent.trim() !== money(item.hot)) {
          if (!('etolieCena' in node.dataset)) node.dataset.etolieCena = node.textContent;
          node.textContent = money(item.hot);
        }
      });
    }
  }

  odznacz() {
    // Tylko elementy dodane przez oznacz() na kafelkach produktów i PDP; plakietki HOT w karcie hot (snippet) zostają.
    document.querySelectorAll('.etolie-card .etolie-hot__flag, .etolie-hot__cardprice, .etolie-hot__pdp').forEach((node) => node.remove());
    document.querySelectorAll('.etolie-card [data-etolie-card-price][hidden]').forEach((node) => { node.hidden = false; });
    if (document.documentElement.classList.contains('etolie-hot-live')) { document.documentElement.classList.remove('etolie-hot-live'); location.reload(); } // po 20:30 karta produktu wraca do zwykłych cen
  }
}

if (!customElements.get('etolie-hot-oferta')) customElements.define('etolie-hot-oferta', EtolieHotOferta);
